module.exports = __webpack_public_path__ + "static/media/country_cl.2607d466.webp";